import { Nav } from "@/components/showcase/Nav";
import { Logo } from "@/components/showcase/Logo";
import { Hero } from "@/components/showcase/Hero";
import { Problem } from "@/components/showcase/Problem";
import { Flow } from "@/components/showcase/Flow";
import { Cadence } from "@/components/showcase/Cadence";
import { Scenarios } from "@/components/showcase/Scenarios";
import { WorkerUploads } from "@/components/showcase/WorkerUploads";
import { CoordinatorView } from "@/components/showcase/CoordinatorView";
import { Benchmarks } from "@/components/showcase/Benchmarks";
import { Cta } from "@/components/showcase/Cta";

export default function Showcase() {
  return (
    <>
      <Nav />
      <main className="min-h-screen bg-white text-ink-900">
        <Problem />
        <Hero />
        <Flow />
        <Cadence />
        <Scenarios />
        <WorkerUploads />
        <CoordinatorView />
        <Benchmarks />
        <Cta />
        <Footer />
      </main>
    </>
  );
}

function Footer() {
  return (
    <footer className="bg-ink-900 text-ink-400 py-12 border-t border-ink-800">
      <div className="mx-auto max-w-[1320px] px-6 flex flex-wrap items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <Logo height={22} />
          <span className="text-xs text-ink-500">
            Moduł Analiza Postępu Remontów · platforma Foton
          </span>
        </div>
        <span className="font-mono text-xs">© {new Date().getFullYear()}</span>
      </div>
    </footer>
  );
}
